import React, { useRef } from "react";
import { Form } from "react-bootstrap";

const ImageUploader = ({
  label,
  name,
  multiple = false,
  images,
  onChange,
  onRemove,
  accept = "image/*",
  status
}) => {
  const inputRef = useRef();

  const handleFileChange = (e) => {
    onChange(e);
    // Reset the input after uploading
    if (inputRef.current) {
      inputRef.current.value = null;
    }
  };

  return (
    <Form.Group className="mb-3 mt-2">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        ref={inputRef}
        name={name}
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleFileChange}
        disabled={status === 'approved'}
      />
      <div className="d-flex flex-wrap mt-2">
        {images.map((src, idx) => (
          <div
            key={idx}
            className="position-relative mx-2 mb-2"
            style={{ display: "inline-block" }}
          >
            <img
              src={src.image_url || src}
              alt="Preview"
              className="img-thumbnail"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
            <button
              type="button"
              onClick={() => onRemove(idx)}
              className="btn-close"
              aria-label="Remove"
              disabled={status === 'approved'}
              style={{
                position: "absolute",
                top: "2px",
                right: "2px",
                backgroundColor: "white",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                padding: "0",
                fontSize: "14px",
                textAlign: "center",
                lineHeight: "1",
                boxShadow: "0 0 3px rgba(0,0,0,0.3)",
              }}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </Form.Group>
  );
};

export default ImageUploader;
